// extracted by mini-css-extract-plugin
export default {"container":"hero_container__vgGfv","logo":"hero_logo__exUtO","hide":"hero_hide__sLtJQ","button":"hero_button__BguDc"};